import { FORM_TYPE } from 'src/constants/proposal';
import { SUBSCRIPTION_FORM_TYPE } from 'src/constants/subscription';

import { ISaveArticleFormParams, ISaveIdeaFormParams, ISaveSubscriptionFormParams } from '../interfaces/frombuilder';

import { ProxyClient } from './client/ProxyClient';

export const sendForm = async (
  type: FORM_TYPE | SUBSCRIPTION_FORM_TYPE,
  params: ISaveArticleFormParams | ISaveIdeaFormParams | ISaveSubscriptionFormParams,
) => {
  const { data } = await ProxyClient.post('/form/save', { type, ...params });

  return data;
};
